import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import ScorecardSelector from '@v4/utils/selectors/ScorecardSelector'
import { ELEMENTS } from './ActionButton.const'

export const useActionButton = ({
	className,
	action,
	children,
	href,
	onClick,
	editable,
	onChange,
	rounded,
	...rest
}) => {
	const type = PageBuilderSelector.useType()
	const signUpLocation = ScorecardSelector.useSignUpLocation()

	const Element = ELEMENTS[type]?.[action] || null

	return [
		{
			key: `${action}_${signUpLocation}`,
			Element,
			className,
			children,
			href,
			editable,
			rounded,
			rest,
			action,
		},
		{
			handleClick: onClick,
			handleChange: onChange,
		},
	]
}
